<template>
    <b-container>
        <b-row>
            <b-col class="pt-2 pb-md-3">
                <b-row>
                    <b-col cols="3" md="5" lg="4">
                        <div class="aspect-ratio mt-2" :class="getClassAspectRatio">
                            <div class="aspect-content">
                                <nuxt-link :to="product.route">
                                    <LazyLoad image_class="object-fit-cover" :photo="imageUrl(product.foto)" :alt="product.nome" :title="product.nome"/>
                                </nuxt-link>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="9" md="7" lg="8" class="pl-0">
                        <div class="cart-product-name d-flex">
                            <div>
                                <div class="mb-2">
                                    <nuxt-link :to="product.route" class="py-2">{{ product.nome }}</nuxt-link>
                                </div>
                                <nuxt-link :to="`/lista-de-presentes/listas/${product.lista.codigo}`" v-if="product.lista && product.lista.codigo > 0">
                                    <small>Lista: {{ product.lista.nome }}</small></nuxt-link>
                            </div>
                            <span class="ml-auto d-md-none pl-3">
                                <button class="cart-delete-product cart-delete-mobile btn" @click="deleteProduct(product)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15.999" height="16" viewBox="0 0 15.999 16">
                                        <path class="a" d="M1531.343,447.656A8,8,0,1,1,1537,450,7.947,7.947,0,0,1,1531.343,447.656Zm.643-10.67a7.089,7.089,0,1,0,5.013-2.077A7.1,7.1,0,0,0,1531.986,436.986Zm7.892,8.538L1537,442.643l-2.883,2.882a.443.443,0,0,1-.319.135.458.458,0,0,1-.319-.135.451.451,0,0,1,0-.643l2.882-2.883-2.882-2.882a.455.455,0,0,1,.643-.643l2.882,2.883,2.883-2.883a.455.455,0,0,1,.643.643L1537.643,442l2.875,2.883a.453.453,0,0,1,0,.643.437.437,0,0,1-.319.135A.458.458,0,0,1,1539.878,445.524Z" transform="translate(-1529 -433.999)"/>
                                    </svg>
                                </button>
                            </span>
                        </div>
                        <div>
                            <span v-for="(additional, additional_key) in product.adicionais">
                                <span v-if="additional_key > 0">, </span>{{ additional.item_nome }}: {{ additional.valor_nome }}
                            </span>
                        </div>
                        <div class="d-flex flex-btn-obs mb-2 flex-sm-row flex-md-column flex-lg-row">
                            <button type="button" class="btn-default mt-2" :class="{'mr-2 mr-md-0 mr-lg-2': product.anexos.length}" @click="show_modal('observation', product)" v-if="product.observacao.ativo">
                                <template v-if="product.observacao.texto">
                                    <span>
                                        Editar observação<span v-if="product.observacao.obrigatorio" title="Obrigatório">*</span>
                                    </span>
                                </template>
                                <template v-else>
                                    <span>
                                        Inserir observação<span v-if="product.observacao.obrigatorio" title="Obrigatório">*</span>
                                    </span>
                                </template>
                            </button>
                            <button type="button" class="btn-default mt-2" @click="show_modal('file', product)" v-if="product.anexos.length">
                                <template v-if="product.anexos[0].arquivo">
                                    <span>
                                        Arquivo enviado - reenviar<span v-if="product.anexos[0].obrigatorio" title="Obrigatório">*</span>
                                    </span>
                                </template>
                                <template v-else>
                                    <span>
                                        Enviar arquivo<span v-if="product.anexos[0].obrigatorio" title="Obrigatório">*</span>
                                    </span>
                                </template>
                            </button>
                        </div>
                        <div v-for="error in errors">
                            <small class="text-danger d-block mt-2" style="line-height: 1.15" v-html="error"></small>
                        </div>
                        <div class="text-danger d-block mt-1" v-if="!isValidFreightInCoupon(product.codigo)">Produto não compatível com o cupom</div>
                        <div class="text-success d-block mt-1" v-if="isValidInCoupon(product.codigo) && showCouponSuccessInProduct">Cupom aplicado a este produto</div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="7" class="py-2">
                <b-row class="d-flex">
                    <b-col md="3" class="d-none d-md-flex justify-content-center">
                        <div class="cart-product-price-unit py-2">{{ product.valor_unitario | currency }}</div>
                    </b-col>
                    <b-col cols="6" md="4" class="product">
                        <div class="qty d-flex mx-md-auto cart-qty-product-cart">
                            <button class="decrease" :disabled="product.quantidade_minima > 0 ? product.quantidade <= product.quantidade_minima : product.quantidade <= 1" @click="changeQtyInCart(product, '-')">-</button>
                            <input v-model="qty" v-money="money" class="number" @keydown="$event.key === '-' ? $event.preventDefault() : null" @blur="validQtyInCart(product, $event.target.value)" @keyup.enter="validQtyInCart(product, qty)"/>
                            <button class="increase" :disabled="product.quantidade_maxima > 0 && product.quantidade >= product.quantidade_maxima" @click="changeQtyInCart(product, '+')">+</button>
                        </div>
                    </b-col>
                    <b-col cols="6" md="5" class="d-flex justify-content-end">
                        <div class="cart-product-price ml-auto py-2">{{ product.valor_total | currency }}</div>
                        <button class="cart-delete-product d-none d-md-block mr-3 ml-auto btn" @click="deleteProduct(product)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.999" height="16" viewBox="0 0 15.999 16">
                                <path d="M1531.343,447.656A8,8,0,1,1,1537,450,7.947,7.947,0,0,1,1531.343,447.656Zm.643-10.67a7.089,7.089,0,1,0,5.013-2.077A7.1,7.1,0,0,0,1531.986,436.986Zm7.892,8.538L1537,442.643l-2.883,2.882a.443.443,0,0,1-.319.135.458.458,0,0,1-.319-.135.451.451,0,0,1,0-.643l2.882-2.883-2.882-2.882a.455.455,0,0,1,.643-.643l2.882,2.883,2.883-2.883a.455.455,0,0,1,.643.643L1537.643,442l2.875,2.883a.453.453,0,0,1,0,.643.437.437,0,0,1-.319.135A.458.458,0,0,1,1539.878,445.524Z" transform="translate(-1529 -433.999)"/>
                            </svg>
                        </button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import utils from '~/mixins/utils';
    import order from '~/mixins/order';
    import LazyLoad from "~/components/LazyLoad";
    import ecommerce_cart from "~/mixins/ecommerce_cart";
    import {VMoney} from 'v-money'

    export default {
        directives: {
            money: VMoney
        },
        components: {
            LazyLoad
        },
        mixins: [
            utils,
            order,
            ecommerce_cart
        ],
        props: {
            product: {
                default: () => {
                }
            },
            errors: {
                default: () => []
            }
        },
        data() {
            return {
                qty: 0
            }
        },
        mounted() {
            this.qty = parseFloat(this.product.quantidade).toFixed(this.product.unidade_precisao || 0)
        },
        computed: {
            money() {
                return {
                    decimal: '.',
                    thousands: '',
                    prefix: '',
                    suffix: '',
                    precision: this.product.unidade_precisao || 0,
                    masked: false
                }
            }
        },
        methods: {
            show_modal(type, product) {
                this.$emit('show-modal', type, product)
            }
        },
        watch: {
            'product.quantidade'(newval) {
                this.qty = parseFloat(newval).toFixed(this.product.unidade_precisao || 0)
            }
        }
    }
</script>
